let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ku4Bh")).then(() => parcelRequire('QQ1JK'));